export default __webpack_public_path__ + "static/media/bnr-ly2.d80aa2cd.png";